import React from 'react'
import style from './Rating.module.scss'

export interface IRatingProps {
  rating: number
  size: 'big' | 'small'
}

const Rating = ({ rating, size = 'big' }: IRatingProps) => {
  const roundedRating = Math.round(rating * 2) / 2
  const emptyPercentage = 100 - (roundedRating / 5) * 100

  return (
    <div className={`${style.rating} ${'big' === size ? style.big : style.small}`}>
      <div className={style.starsFill} />
      <div className={style.wrapper} style={{ width: `${emptyPercentage}%` }}>
        <div
          className={style.starsEmpty}
          style={{ minHeight: 'big' === size ? '20px' : '12px', minWidth: 'big' === size ? '96px' : '60px' }}
        />
      </div>
    </div>
  )
}

export default Rating
